var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "181",
        height: "136",
        viewBox: "0 0 181 136",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: { d: "M180.997 0H0V135.588H180.997V0Z", fill: "#7FD2D5" },
      }),
      _c("path", {
        attrs: { d: "M181.006 0H90.5078V135.588H181.006V0Z", fill: "#37979B" },
      }),
      _c("path", {
        attrs: {
          d: "M90.4984 67.7922H180.997V135.586H0C0 98.1445 40.5176 67.7922 90.4984 67.7922Z",
          fill: "#4FB6BB",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }